module.exports = __webpack_public_path__ + "img/educacion.ef48610f.svg";